<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar v-if="!environment" title="退换/售后" left-arrow   @click-left="goBack"/>
      <van-tabs v-model="active" @click="onClickActive">
        <van-tab title="售后申请"> </van-tab>
        <van-tab title="处理中"> </van-tab>
        <van-tab title="申请记录"></van-tab>
      </van-tabs>
    </van-sticky>
    <product v-if="active === 0"></product>
     <processing v-if="active === 1"></processing>
    <record v-if="active === 2"></record>
  </div>
</template>

<script>
import { productList, recordList, processingList } from '@/api/after-sale'
import Product from './component/Product'
import Record from './component/Record'
import Processing from './component/Processing'
export default {
  components: {
    Product,
    Record,
    Processing
  },
  data() {
    return {
      environment:'',
      active: 0,
      list: [],
      query: {
        current: 1,
        size: 10,
        keyword:''
      },
    }
  },
  created() {
    this.getIsWxMiniProgram()
    // this.getProductList()
    // this.getRecordList()
    // this.getProcessingList()
   
  },
  methods: {
     // 判断是否小程序
    async getIsWxMiniProgram() {
      const WxMiniProgram = await this.$getIsWxMiniProgram()
      console.log('WxMiniProgram', WxMiniProgram);
      if (WxMiniProgram) {
        this.environment = true
      } else {
        this.environment = false
      }
    },
    onClickActive() {
      // if(this.active)
    },
    getProductList() {
      productList(this.query).then(({ data }) => {
        if (data.code === 200) {
          this.list = data.data
          console.log(data.data)
        }
      })
    },
    getRecordList() {
      recordList(this.query).then(({ data }) => {
        if (data.code === 200) {
          this.list = data.data
          console.log(data.data)
        }
      })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    getProcessingList() {
      processingList(this.query).then(({ data }) => {
        if (data.code === 200) {
          this.list = data.data
          console.log(data.data)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  color: #646566;
  min-height: 100vh;
  background: rgb(246, 246, 246);
}
.list {
  background: #fff;
  // margin-top: 10px;
  border-top: 10px solid rgb(246, 246, 246);
  padding: 10px;
  .card-title {
    padding: 0px 15px 10px 0px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .card {
    display: flex;
    p {
      font-size: 14px;
      margin: 0 0 10px 0;
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
  .card-status {
    min-height: 55px;
    justify-content: space-between;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    font-size: 14px;
    align-items: center;
    padding: 5px 15px;
    background: rgb(246, 246, 246);
    color: #848484;
    p {
      margin: 2.5px 0;
    }
    /deep/.van-icon {
      color: #848484;
      font-size: 20px;
    }
    .status {
      margin-right: 15px;
    }
  }
  .card-btn {
    display: flex;
    justify-content: space-between;
    padding: 10px 5px 0px 0px;
    /deep/ .van-button--round {
      margin-right: 15px;
      border-color: #ee0a24;
      /deep/.van-button__text {
        color: #ee0a24;
      }
    }
    span {
      font-size: 12px;
      color: #848484;
    }
  }
  .line {
    margin: 0px 15px 10px 15px;
    height: 1px;
    background: rgb(246, 246, 246);
  }
}
</style>